// The eleven agents as they appear in "The lineup" and "What we automate" on
// /ai/. One source, so the two blocks always agree. `slug` is the agent page the
// "Read more" link opens.
export const agents = {
  'purchase-order-follow-up': {
    title: 'Purchase order follow-up',
    description:
      'We find purchase orders due with no appointment, and get the supplier or carrier to book before stock runs short.',
    metric: '40–50%',
    label: 'more on-time deliveries',
  },
  'tender-failures': {
    title: 'Tender failures',
    description:
      'We re-tender down your routing guide and re-book before the miss ever reaches your team.',
    metric: '8–10%',
    label: 'overpayment on flat rates eliminated',
  },
  'tracking-and-status-updates': {
    title: 'Tracking & status updates',
    description:
      'We pull status from carriers and push clean updates, so your team stops making check calls.',
    metric: '5–10',
    label: 'minutes saved per tracked load',
  },
  'proactive-load-audits': {
    title: 'Proactive load audits',
    description:
      'We check every load before pickup and flag at-risk transit before it becomes a penalty.',
    metric: '30–40%',
    label: 'reduction in avoidable penalty charges',
  },
  'scheduling-and-re-scheduling': {
    title: 'Scheduling & re-scheduling',
    description:
      'We book dock appointments, and when a pickup slips, re-schedule and notify everyone.',
    metric: '5–10',
    label: 'minutes saved per appointment',
  },
  'dock-schedule-management': {
    title: 'Dock door management',
    description:
      'We keep the dock schedule on plan, handling late arrivals, no-shows and closed doors, with daily briefings and appointment reminders.',
    metric: '20–30%',
    label: 'better dock utilization',
  },
  'yard-task-orchestration': {
    title: 'Yard task orchestration',
    description:
      'We create, assign and sequence yard tasks, from moves to temperature checks, and tell suppliers and carriers when something needs them.',
    metric: '20–30%',
    label: 'higher yard labor productivity',
  },
  'warehouse-customer-service': {
    title: 'Warehouse customer service',
    description:
      'We answer your warehouse’s status questions and book appointments from an email, using your dock schedule and WMS.',
    metric: '65–75%',
    label: 'of customer questions answered without a person',
  },
  'detention-handling': {
    title: 'Detention handling',
    description:
      'We warn the dock before free time runs out, and approve detention requests that match the gate record.',
    metric: '50–65%',
    label: 'lower detention fees',
  },
  'document-collection-and-filing': {
    title: 'Document collection & filing',
    description: 'Automate collection of PoDs, Invoices and other documents.',
    metric: '70–90%',
    label: 'less document-handling time',
  },
  'claims-processing': {
    title: 'Claims processing',
    description:
      'We gather the docs, validate the claim, and draft the response for your approval.',
    metric: '2×',
    label: 'faster claims recovery with higher filing rates',
  },
};

// The lifecycle stages, in order, with the agents that belong to each.
export const stages = [
  {
    id: 'plan',
    label: 'Plan & procure',
    slugs: ['purchase-order-follow-up', 'tender-failures'],
  },
  {
    id: 'execute',
    label: 'Execute',
    slugs: [
      'tracking-and-status-updates',
      'proactive-load-audits',
      'scheduling-and-re-scheduling',
    ],
  },
  {
    id: 'gate-yard-dock',
    label: 'Gate · Yard · Dock',
    slugs: [
      'dock-schedule-management',
      'yard-task-orchestration',
      'warehouse-customer-service',
      'detention-handling',
    ],
  },
  {
    id: 'settle',
    label: 'Settle',
    slugs: ['document-collection-and-filing', 'claims-processing'],
  },
];
